import { useEffect, useState } from "react";
import { api, AppConfig, ApiError } from "../api/client";
import { useToast } from "../ui/toast";

/** Warunki zwrotu i prawo odstąpienia — edit the return terms served via /config and accepted at checkout. */
export function ReturnPolicy() {
  const toast = useToast();
  const [cfg, setCfg] = useState<AppConfig | null>(null);
  const [original, setOriginal] = useState<AppConfig | null>(null);
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    api.getConfig()
      .then((c) => { setCfg(c); setOriginal(c); })
      .catch((e: ApiError) => toast(e.status === 403 ? "Brak dostępu (owner-only)." : e.message));
  }, [toast]);

  if (!cfg || !original) return <div className="card empty">Ładowanie…</div>;
  const changed =
    cfg.returns.text !== original.returns.text || (cfg.returns.textEn ?? "") !== (original.returns.textEn ?? "");

  const save = async () => {
    setBusy(true);
    try {
      const saved = await api.saveConfig(cfg);
      setCfg(saved);
      setOriginal(saved);
      toast(`Zapisano warunki zwrotu (wersja ${saved.returns.version})`);
    } catch (e) {
      toast((e as ApiError).message);
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="card" style={{ padding: 20, maxWidth: 860 }}>
      <div className="section-title" style={{ marginBottom: 4 }}>Warunki zwrotu i prawo odstąpienia</div>
      <div className="section-hint">
        Treść jest serwowana pod <code>/warunki-zwrotu</code> i pokazywana klientowi przy składaniu
        zamówienia w portalu. Klient musi je zaakceptować (TAK/NIE), aby przejść do płatności —
        bez akceptacji zakup jest zablokowany. Każda zmiana <b>podbija wersję</b> warunków.
      </div>

      <div className="field" style={{ marginTop: 14 }}>
        <label className="label">Treść warunków zwrotu</label>
        <textarea
          className="textarea"
          style={{ minHeight: 360 }}
          value={cfg.returns.text}
          placeholder="Wpisz treść warunków zwrotu i prawa odstąpienia…"
          onChange={(e) => setCfg({ ...cfg, returns: { ...cfg.returns, text: e.target.value } })}
        />
      </div>

      <div className="field" style={{ marginTop: 14 }}>
        <label className="label">Treść w języku angielskim (EN) — pokazywana klientom, którzy wybrali English</label>
        <textarea
          className="textarea"
          style={{ minHeight: 340 }}
          value={cfg.returns.textEn ?? ""}
          placeholder="Enter the English version of the return / withdrawal terms…"
          onChange={(e) => setCfg({ ...cfg, returns: { ...cfg.returns, textEn: e.target.value } })}
        />
      </div>

      <div className="row" style={{ marginTop: 12 }}>
        <span className="faint" style={{ fontSize: 12 }}>Aktualna wersja: {original.returns.version}</span>
        {changed && (
          <span className="badge st-expiring" style={{ marginLeft: 8 }}>
            <span className="dot dot-expiring" />wersja zostanie podbita
          </span>
        )}
        <div className="topbar-spacer" />
        <button className="btn primary" disabled={busy || !changed} onClick={save}>Zapisz warunki</button>
      </div>
    </div>
  );
}
